module.exports = __webpack_public_path__ + "static/media/06.b2c076cc.mp3";